import styled from 'styled-components';

export const StyledBanner = styled.div<{ alignment?: string; fullWidth: boolean }>`
  display: ${(props) => (props.fullWidth ? 'block' : 'flex')};
  justify-content: ${(props) => (props.alignment ? props.alignment : 'center')};
  align-items: center;
  width: 100%;

  @media (max-width: 374px) {
    max-height: 50px;
    ${(props) => !props.fullWidth && 'aspect-ratio: 320/50;'}
  }
  @media ((min-width: 375px) and (max-width: 767px)) {
    max-height: 90px;
    ${(props) => !props.fullWidth && 'aspect-ratio: 728/90;'}
  }
  @media (min-width: 768px) {
    max-height: ${(props) => (props.fullWidth ? '120px' : '90px')};
    ${(props) => !props.fullWidth && 'aspect-ratio: 970/90;'}
  }
`;

export const StyledPicture = styled.picture`
  display: flex;
`;

export const StyledImage = styled.img<{ fullWidth: boolean }>`
  display: inline-block;
  width: 100%;

  @media (max-width: 374px) {
    ${(props) => !props.fullWidth && 'aspect-ratio: 320/50;'}
    ${(props) => !props.fullWidth && ' max-width: 320px;'}
    max-height: 50px;
  }
  @media ((min-width: 375px) and (max-width: 767px)) {
    ${(props) => !props.fullWidth && 'aspect-ratio: 728/90;'}
    ${(props) => !props.fullWidth && 'max-width: 728px;'}
    max-height: 90px;
  }
  @media (min-width: 768px) {
    ${(props) => !props.fullWidth && 'aspect-ratio: 970/90;'}
    ${(props) => !props.fullWidth && 'max-width: 970px;'}
    max-height: 90px;
  }
  @media (min-width: 1024px) {
    ${(props) => props.fullWidth && 'max-height: 120px;'}
  }
`;
